// src/pages/Users/UserForm.jsx
// -----------------------------------------------------------------------------
// Wrapper component that forwards all props to the reusable TableForm generator.
// Maintains architectural alignment while using the generic form renderer.
// -----------------------------------------------------------------------------
import TableForm from '../../components/common/TableForm';

export default function UserForm(props) {
  return <TableForm {...props} />;
}
